import { StockItemData } from "@/types/stock";

export const getProductName = (data: StockItemData): string => {
  if (!data) return 'N/A';
  
  // Pour les volailles, utiliser Race en priorité
  if (data.Race) {
    return data.Race;
  }
  
  // Sinon utiliser le nom du produit
  if (data.name) {
    return data.name;
  }

  console.warn('Aucun nom trouvé dans:', data);
  return 'N/A';
};